import {FilterType, IGameFilter} from './game-filter.interface';
import {GameInfo} from '../../games/game-info';
import {ActiveFilter} from '../games-filter.service.interface';
import {removeSpaces} from "../../../../utils/string-helpers";

export class VendorFilter implements IGameFilter {
  constructor(private _vendorName: string) {

  }
  get filterType(): FilterType {
    return FilterType.featureFilter;
  }

  applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean {
    return removeSpaces(gameInfo.vendorName.toLowerCase()) === removeSpaces(this._vendorName.toLowerCase());
  }

}
